export const MANUAL_CASHFLOW_SOURCE = 'Manual Targets'
